export const environment = {
    name: "dev",
    production: false,
    rootAuthnUrl: "https://dev.authn.spectrumreach.io",
    baseBreUrl: "https://dev.xdds.spectrumreach.io",
    baseUrl: "https://dev.admin.spectrumreach.io",
    adminPermissionName: "adminUIAccess",
    cognito: {
        customProviderName: "ESSO",
        Auth: {
            region: "us-east-1",
            userPoolId: "us-east-1_3WdKtqKvl",
            userPoolWebClientId: "f55in71mbemq2fphgnmns9lvk",
        },
        oauth: {
            domain: "srd-users-dev.auth.us-east-1.amazoncognito.com",
            redirectSignIn: "https://dev.admin.spectrumreach.io/",
            redirectSignOut: "https://dev.admin.spectrumreach.io/",
            responseType: "token",
        }
    },
    allowCognitoAuth: true
};